/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { useEffect } from 'react';
import { useSearchParams } from './useSearchParams';
import { getAnalytics } from '../services/analytics/AnalyticsService';
import { AnalyticsEvents } from '../services/analytics/AnalyticsEvents';

export const useSubscriptionCheckoutSuccess = () => {
  const searchParams = useSearchParams();
  const checkout = searchParams.get('checkout');
  const checkoutSuccess = checkout === 'success';
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (checkoutSuccess) {
      const analytics = getAnalytics();
      analytics.track(AnalyticsEvents.CheckoutSessionCompleted, {
        sessionId
      });
    }
  }, [checkoutSuccess, sessionId]);
}
